import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  TutorialVideoSummary,
  TutorialVideoUpdatePayload,
  TutorialVideoUploadPayload,
} from '../../model/tutorial-video.model';

const PUBLIC_URL = `${environment.apiBaseUrl}/tutorial-videos`;
const ADMIN_URL = `${environment.apiBaseAdminUrl}/tutorial-videos`;

@Injectable({ providedIn: 'root' })
export class TutorialVideoService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<TutorialVideoSummary[]> {
    return this.http.get<TutorialVideoSummary[]>(PUBLIC_URL);
  }

  streamUrl(tutorialId: string): string {
    return `${PUBLIC_URL}/${encodeURIComponent(tutorialId)}/stream`;
  }

  upload(payload: TutorialVideoUploadPayload): Observable<TutorialVideoSummary> {
    const formData = new FormData();
    formData.append('tutorialId', payload.tutorialId);
    formData.append('file', payload.file, payload.file.name);
    return this.http.post<TutorialVideoSummary>(ADMIN_URL, formData);
  }

  update(payload: TutorialVideoUpdatePayload): Observable<TutorialVideoSummary> {
    const formData = new FormData();
    if (payload.newTutorialId && payload.newTutorialId !== payload.tutorialId) {
      formData.append('newTutorialId', payload.newTutorialId);
    }
    if (payload.file) {
      formData.append('file', payload.file, payload.file.name);
    }
    return this.http.put<TutorialVideoSummary>(
      `${ADMIN_URL}/${encodeURIComponent(payload.tutorialId)}`,
      formData,
    );
  }

  delete(tutorialId: string): Observable<void> {
    return this.http.delete<void>(`${ADMIN_URL}/${encodeURIComponent(tutorialId)}`);
  }
}
